var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSizingTable(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 26,
    viewBox: "0 0 34 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.4767 0.976477H1.7567C1.56044 0.976477 1.37222 1.05444 1.23344 1.19322C1.09466 1.332 1.0167 1.52022 1.0167 1.71648V23.4765C1.0167 24.0122 1.22952 24.526 1.60834 24.9048C1.98717 25.2837 2.50096 25.4965 3.0367 25.4965H31.1967C31.7324 25.4965 32.2462 25.2837 32.6251 24.9048C33.0039 24.526 33.2167 24.0122 33.2167 23.4765V1.71648C33.2167 1.52022 33.1387 1.33199 33 1.19322C32.8612 1.05444 32.673 0.976477 32.4767 0.976477ZM2.4967 10.1365H9.9767V16.3365H2.4967V10.1365ZM11.4567 10.1365H31.7367V16.3365H11.4567V10.1365ZM31.7367 2.45648V8.65648H2.4967V2.45648H31.7367ZM2.4967 23.4765V17.8165H9.9767V24.0165H3.0367C2.89348 24.0165 2.75613 23.9596 2.65486 23.8583C2.55359 23.757 2.4967 23.6197 2.4967 23.4765ZM31.1967 24.0165H11.4567V17.8165H31.7367V23.4765C31.7367 23.6197 31.6798 23.757 31.5785 23.8583C31.4773 23.9596 31.3399 24.0165 31.1967 24.0165Z",
    fill: "#A69797",
    stroke: "#A69797",
    strokeWidth: 0.2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSizingTable);
export default __webpack_public_path__ + "static/media/sizing-table.bac597dd08ab6ab286eef3911adb3edb.svg";
export { ForwardRef as ReactComponent };